import type { HTMLAttributes } from "react";
import { cn } from "../../lib/cn";

export function ListworkMark({ className, ...props }: HTMLAttributes<HTMLSpanElement>) {
  return (
    <span className={cn("listwork-symbol", className)} aria-hidden="true" {...props}>
      <svg viewBox="0 0 640 540" role="presentation">
        <circle className="listwork-symbol-signal" cx="598" cy="60" r="40" />
        <path
          className="listwork-symbol-bird"
          fillRule="evenodd"
          d="M0 504C36 473 76 430 106 386c26-53 51-99 84-140 33-40 76-69 105-113 24-36 29-78 54-109 26-32 75-31 108-12 18 11 25 15 56 20l69 22c-47-3-82 1-108 19-24 17-31 36-30 63 1 27 11 43 10 74-1 61-23 113-63 157-23 25-51 46-84 65-5 3-6 9-3 15l36 67 68 26h-126l42-24-59-68c-24-28-68-36-107-21-38 15-61 52-94 65-20 8-42 12-64 12Zm377-335c-18 66-52 111-104 150-45 33-91 58-138 78 63 10 119-4 165-32 46-28 70-70 78-120 5-31 3-59-1-76Z"
        />
      </svg>
    </span>
  );
}
